import {executeFirstTimeIsVisible} from "./dom";

const GOOGLE_INITIALIZE_CALLBACK = 'googleInitialize';

let googleMapsScriptAdded = false;
let googleMapsInitialized = false;
const registeredCallbacks = [];

function addGoogleMapsScript() {
    const mapsJS = document.createElement('script');
    mapsJS.src = window.GOOGLE_MAPS_URL + '&callback=' + GOOGLE_INITIALIZE_CALLBACK;
    document.getElementsByTagName('head')[0].appendChild(mapsJS);
}

function loadGoogleMaps() {
    if (!googleMapsScriptAdded) {
        addGoogleMapsScript();
        googleMapsScriptAdded = true;
    }
}

function googleInitialize() {
    if (!googleMapsInitialized) {
        registeredCallbacks.forEach(callback => callback());
        googleMapsInitialized = true;
    }
}

window[GOOGLE_INITIALIZE_CALLBACK] = googleInitialize;

export function registerGoogleMapsCallback(callback) {
    registeredCallbacks.push(callback);
    if (googleMapsInitialized) callback();
}

export function executeWithGoogleMaps(callback) {
    loadGoogleMaps();
    registerGoogleMapsCallback(callback);
}

export function executeWithGoogleMapsFirstTimeIsVisible(element, callback) {
    executeFirstTimeIsVisible(element, () => executeWithGoogleMaps(callback));
}
